import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { CardType } from './card-type.model';
import { CardTypeService } from './card-type.service';
import { Principal, CARD_UNLIMITED_BOOKINGS_NUMBER} from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-card-type',
    templateUrl: './card-type.component.html'
})
export class CardTypeComponent implements OnInit, OnDestroy {
    cardTypes: CardType[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;
    itemsPerPage: any;
    page: any;
    predicate: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private cardTypeService: CardTypeService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['cardType']);
        // TODO : remove this value and code pagination
        this.itemsPerPage = 100;
    }

    loadAll() {
        if (this.currentSearch) {
            this.cardTypeService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(
                (res: HttpResponse<CardType[]>) => this.cardTypes = res.body,
                (res: HttpErrorResponse) => this.onError(res)
                );
            return;
        }
        this.cardTypeService.query({
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(
            (res: HttpResponse<CardType[]>) => {
                this.cardTypes = res.body;
                this.currentSearch = '';
            },
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInCardTypes();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: CardType) {
        return item.id;
    }

    getMaxAssistances() {
        return CARD_UNLIMITED_BOOKINGS_NUMBER;
    }

    registerChangeInCardTypes() {
        this.eventSubscriber = this.eventManager.subscribe('cardTypeListModification', (response) => this.loadAll());
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }
    sort() {
        let result = ['name,asc'];
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type.component.ts